/** @format */

import React from 'react'

import { Button } from 'antd'

import './style.css'

export default function BtnSubmit(props) {
	return (
		<Button
			loading={props.loadingSubmit}
			type='primary'
			htmlType='submit'
			className='ph-login-button-register'>
			{props.labelName}
		</Button>
	)
}
